// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { connect } from 'react-redux';

// eslint-disable-next-line
import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PersonIcon from '@material-ui/icons/Person';

import * as coreSelectors from '../core/selectors';

import * as serviceActions from './actions';
import * as serviceSelectors from './selectors';
import * as MessageFormat from './MessageFormat';
import * as Formatters from '../ui/Formatters';
import * as PortalApi from '../PortalApi';

import OutlinedPopover from '../ui/OutlinedPopover';
import { withTranslation } from 'react-i18next';

const styles = theme => ({
    root: {
        fontFamily: 'Sofia, sans-serif',
        '& *': {
            fontFamily: 'Sofia, sans-serif',
        },
    },
});

/*
 * Display a popover when clicking on a message
 */
class Assist extends Component {
  state = {
    open : false,
    submitting : false,
    locationId: undefined,
    requestType: 'ASSIST',
    request: '',
    phoneNumberId : undefined,
    authorized: false,
  }

  defaultPhoneNumber = () => {
    /* If the phone number is not set, see if their selection is stored */
    if (!Boolean(this.state.phoneNumberId) && localStorage.getItem("phoneNumberId")) {
      this.setState({phoneNumberId: Number(localStorage.getItem("phoneNumberId"))});
      return;
    }
    
    /* Unselect if they no longer have access for some reason */
    if (Boolean(this.state.phoneNumberId)) {
      let number = this.props.user.assistPatchNumbers
                       ?.find(number => number.phoneNumberId === this.state.phoneNumberId);
      if (!Boolean(number)) {
        localStorage.removeItem('phoneNumberId');
        this.setState({phoneNumberId : ''});
      }
      return;
    }
    /* Pick the first one if none selected */
    if (this.props.user && this.props.user.assistPatchNumbers?.length > 0) {
      this.setState({phoneNumberId : this.props.user.assistPatchNumbers[0].phoneNumberId});
      localStorage.setItem('phoneNumberId', String(this.props.user.assistPatchNumbers[0].phoneNumberId));
    }
  }

  phoneNumberChanged = (phoneNumberId) => {
    localStorage.setItem('phoneNumberId', String(phoneNumberId));
    this.setState({ phoneNumberId });
  }
  
  componentDidMount() {
    this.defaultPhoneNumber();    
  }
  
  componentDidUpdate() {
    this.defaultPhoneNumber();
    if (!this.props.assistOpen && this.state.open) {
      this.setState({open: false});
      return;
    }
    
    if (this.props.assistOpen && !this.state.open) {
      if (!this.state.locationId) {
        let locationId;
        if (this.props.user.userAccountRoles.length > 0) {
          locationId = this.props.user.userAccountRoles[0].locationId;
        }
        this.setState({ locationId, open: true, submitting: false});
      } else {
        this.setState({ open: true, submitting: false });
      }
    }
    
  }

  submitRequest = () => {
    this.setState({submitting: true});
    this.props.submitAssist(this.state.locationId, this.state.requestType,
                            this.props.task.taskId,
                            this.props.task.messageId,
                            this.state.phoneNumberId,
                            this.state.request, () => {
                              this.setState({request: '', authorized: false, submitting: false});
                              this.props.setAssistOpen(false);
                              this.props.setAssistTask({});
                            },  (error, status, content) => {
                              PortalApi.defaultErrorHandler(error, status, content);
                              this.setState({submitting: false});
                            });
  }

  render() {
    // eslint-disable-next-line
    const { classes, assistOpen, setAssistOpen,
            user, task,t } = this.props;
    
    let title = 'Request '+t('Assist');
    if (task.taskId) {
      title = 'Request '+t('Assist')+' on "' + MessageFormat.messageSender(task) + '"';
    }

    let canSubmit = !this.state.submitting && this.state.request.length > 0 && this.state.locationId &&
                     this.state.phoneNumberId && (!task.taskId || this.state.authorized);
    
    return (
      <React.Fragment>
        <OutlinedPopover open={assistOpen}
                         icon={<PersonIcon color='primary' fontSize='large'/>}
                         title={title}
                         onClose={() => setAssistOpen(false)}>
          <MuiCore.Grid container spacing={2} className={classes.root}>
            <MuiCore.Typography variant='body2' style={{ margin: "0 0 1rem 10px", fontWeight: 400, fontSize: '1.1em', padding: '0 20px'}}>
                        We&#8217;d be delighted to make an outbound call on your behalf during our business hours, <strong>Monday through Friday from 5 AM to 6 PM PT. </strong> 
                        <br />
                        <br />
                        If you need support from Customer Happiness, please visit our&nbsp;
                <a href="https://rubyhelpcenter.helpjuice.com/contact-us" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', cursor: 'pointer' }}>
                    Help Center
                </a>.
            </MuiCore.Typography>                 
            <MuiCore.Grid item xs={12} >
              <MuiCore.FormControl fullWidth >
                <MuiCore.InputLabel ref={this.durationSelectLabel}
                                    variant='outlined'>
                  Team
                </MuiCore.InputLabel>
                <MuiCore.Select variant='outlined'
                                label='Team'
                                fullWidth
                                onChange={(event) => {
                                  this.setState({requestType: event.target.value});
                                }}
                                value={this.state.requestType}>
                  <MuiCore.MenuItem key='ASSIST'
                                    value='ASSIST'>
                    Assist Team
                  </MuiCore.MenuItem>
                </MuiCore.Select>
              </MuiCore.FormControl>
            </MuiCore.Grid>
      
            <MuiCore.Grid item xs={12} >
              <MuiCore.FormControl fullWidth >
                <MuiCore.InputLabel ref={this.durationSelectLabel}
                                    variant='outlined'>
                   Account / Location
                </MuiCore.InputLabel>
                <MuiCore.Select variant='outlined'
                                label='Account / Location'
                                fullWidth
                                onChange={(event) => {
                                  this.setState({locationId: event.target.value});
                                }}
                                value={this.state.locationId}>
                  {(user.userAccountRoles || []).map(role => (
                    <MuiCore.MenuItem key={role.locationId}
                                      value={role.locationId}>
                      {role.accountName} / {role.locationName}
                    </MuiCore.MenuItem>
                  ))}
                </MuiCore.Select>
                </MuiCore.FormControl>
            </MuiCore.Grid>

      
            <MuiCore.Grid item xs={12} >
              <MuiCore.FormControl fullWidth >
                <MuiCore.InputLabel variant='outlined'>
                   Originating Phone Number for Outcalls
                </MuiCore.InputLabel>
                <MuiCore.Select variant='outlined'
                                label='Originating Phone Number for Outcalls'
                                fullWidth
                                onChange={(event) => {
                                  this.phoneNumberChanged(event.target.value);
                                }}
                     value={this.state.phoneNumberId}>
                  {user.assistPatchNumbers?.map(number =>(
                    <MuiCore.MenuItem key={number.phoneNumberId}
                                      value={number.phoneNumberId}>
                      {Formatters.formatPhoneNumber(number.phoneNumber)}
                    </MuiCore.MenuItem>                    
                  ))}
                </MuiCore.Select>
                </MuiCore.FormControl>
            </MuiCore.Grid>

            <MuiCore.Hidden xlDown={!task.taskId}>
              <MuiCore.Grid item xs={12} >
                <MuiCore.Grid container direction='row' wrap='nowrap' alignItems='center' >
                  <MuiCore.Grid item>
                    <MuiCore.Checkbox value={this.state.authorized}
                                      onChange={(event) => this.setState({authorized: event.target.checked})} />
                  </MuiCore.Grid>
                  <MuiCore.Grid item style={{fontWeight: 'bold'}}>
                    I grant permission for a Ruby Agent to view message contents and listen to voicemails in the referenced activity while fullfilling this request.
                  </MuiCore.Grid>
                </MuiCore.Grid>
              </MuiCore.Grid>
            </MuiCore.Hidden>
      
            
            <MuiCore.Grid item xs={12}>
              <MuiCore.TextField multiline
                                 value={this.state.request}
                                 onChange={(event) => this.setState({request: event.target.value})}
                                 label='Request'
                                 fullWidth rows="10"/>
            </MuiCore.Grid>
            
            <MuiCore.Grid item xs={12} style={{textAlign: 'center'}}>
              <MuiCore.Button
                disabled={!canSubmit}
                onClick={this.submitRequest}>Submit</MuiCore.Button>
            </MuiCore.Grid>
            
          </MuiCore.Grid>
        </OutlinedPopover>
      </React.Fragment>
    );
  }
}


const mapStateToProps = (state) => {
  return ({
    assistOpen : serviceSelectors.getAssistOpen(state),
    user : coreSelectors.getUser(state),
    task : serviceSelectors.getAssistTask(state),
  });
};

const mapDispatchToProps = {
  setAssistOpen : serviceActions.setAssistOpen,
  setAssistTask : serviceActions.setAssistTask,
  submitAssist : serviceActions.submitAssist,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withTranslation()(Assist)));
